export default {
  floatingTopMenu: {
    'openSettings': 'Réglages',
    'showAbout': 'Afficher les informations générales',
    'about': 'À propos d\'ORS',
    'openrouteserviceAPI': 'Openrouteservice API',
    'openrouteserviceForDisasters': 'Openrouteservice pour les catastrophes',
    'askOpenrouteservice': 'Ask openrouteservice',
    'settingsTooltip': 'Cliquez ici si vous souhaitez ajuster les paramètres de l\'application et voir d\'autres options'
  }
}
